import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAdminApi } from "@/hooks/useAdminApi";
import { errMsg } from "@/lib/api";

export const BansTab = () => {
  const call = useAdminApi();
  const [bans, setBans] = useState([]);
  const load = () => call("get", "/admin/bans").then(setBans).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const unban = async (b) => {
    if (!window.confirm(`Unban ${b.email}?`)) return;
    try { await call("delete", `/admin/bans/${b.id}`); toast.success("Unbanned"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-400">Customers banned for fake transaction hashes can't check out or start a chat (blocked by email and connection). Ban someone from an order's detail window.</p>
      <div className="rounded-lg border border-white/10 bg-[#0F1117] divide-y divide-white/5">
        {bans.length === 0 && <p data-testid="bans-empty" className="p-6 text-sm text-gray-500">No banned customers.</p>}
        {bans.map((b) => (
          <div key={b.id} data-testid={`ban-row-${b.id}`} className="flex items-center gap-4 p-4 text-sm">
            <div className="flex-1 min-w-0">
              <p className="font-semibold break-all">{b.email}</p>
              <p className="text-xs text-gray-500 mt-1">{b.reason} · order <span className="font-mono">{b.order_id}</span> · {new Date(b.created_at).toLocaleString()}</p>
            </div>
            <button data-testid={`unban-${b.id}`} onClick={() => unban(b)} className="h-9 px-3 rounded-md border border-white/10 hover:border-emerald-500/60">Unban</button>
          </div>
        ))}
      </div>
    </div>
  );
};
